'use strict';

import axios from 'axios';
import getHeader from '../config/header';
import Format from '../services/formats';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Events = {

    async getAll() {
      try {
        let response = await axios.get(API_URL + '/events', await getHeader());

        return response.data;

      } catch(error) {
              return false;
      }
    },

    async getTotalCount() {
      try {
        let response = await axios.get(API_URL + '/events/countAll', await getHeader());

        return response.data.count;

      } catch(error) {
        return false;
      }
    },
    
    async createNew(event) {
      try {
        if (!event.start || !event.end || !event.museumID || !event.title || !event.eventUrl) {
            return { error: 'A mandatory field is missing' };
        }

        if (isNaN(event.price) && event.price != null) {
            return { error: 'The event price must be a number' };
        }

        event.start = Format.setDateToMidnight(event.start);
        event.end = Format.setDateToMidnight(event.end);

        let response = await axios.post(API_URL + '/event', {
                "title": event.title,
                "startDate": event.start,
                "startTime": event.startingTime,
                "endDate": event.end,
                "endTime": event.endingTime,
                "description": event.description,
                "museumId": event.museumID,
                "price": parseFloat(event.price),
                "eventUrl": event.eventUrl
            }, await getHeader());
        
        if (response.data.id) {
            return response.data;
        }

      } catch(error) {
        return false;
      }
    },

    async update(event) {

        console.log("Editing event: ");
        console.log(event);

      try {
        if (!event.start || !event.end || !event.museumID || !event.title || !event.eventUrl) {
            return { error: 'A mandatory field is missing' };
        }

        if (isNaN(event.price) && event.price != null) {
            return { error: 'The event price must be a number' };
        }

        event.start = Format.setDateToMidnight(event.start);
        event.end = Format.setDateToMidnight(event.end);

        let headers = await getHeader();
        return axios.patch(API_URL + '/event/' + event.id, {
            "title": event.title,
            "startDate": event.start,
            "startTime": event.startingTime,
            "endDate": event.end,
            "endTime": event.endingTime,
            "description": event.description,
            "price": parseFloat(event.price),
            "eventUrl": event.eventUrl ===  "" ? null : event.eventUrl
        }, headers);

      } catch(error) {
        return { error };
      }
    },

    async getByMuseumID(museumID) {
      try {
        if (!museumID) {
          return { error: "No museumID given" }
        }

        let response = await axios.get(API_URL + '/museum/' + museumID + '/events', await getHeader());

        let events = [];

        response.data.forEach(item => {

          if (item.start_time) {
            let startHour = item.start_time.split(':')[0];
            startHour = parseInt(startHour);
            item.start_time = startHour + ':' + item.start_time.split(':')[1]
          }

          if (item.end_time) {
            let endHour = item.end_time.split(':')[0];
            endHour = parseInt(endHour);
            item.end_time = endHour + ':' + item.end_time.split(':')[1]
          }

          if (item.end_date == item.start_date) {
            item['display_end_date'] = item.end_date;
          } else {
            item['display_end_date'] = new Date(item.end_date);
            item['display_end_date'].setDate(item['display_end_date'].getDate() + 1);
            item['display_end_date'] = item['display_end_date'].toISOString();
          }

          events.push(item);
        });

        return events;

      } catch(error) {
        return false;
      }
    },


    async countForMuseum(museumID) {
      try {
        if (!museumID) {
          return { error: "No museumID given" }
        }

        let response = await axios.get(API_URL + '/museum/' + museumID + '/events', await getHeader());

        let comingEvents = 0;

        let now = new Date();

        for (let event of response.data) {
          if (now < new Date(event.end_date)) {
            comingEvents++;
          }
        }

        return comingEvents;

      } catch(error) {
        return false;
      }
    },


    async uploadImage(eventID, filename, content) {
      try {
          if (!eventID || !filename || !content) {
              return { error: 'A mandatory field is missing' };
          }

          let header = await getHeader();

          let response = await axios.post(API_URL + '/event/upload/' + eventID, {
                  "fileName": filename,
                  "content": content
              }, header);
          
          if (response.data) {
              return true;
          }

      } catch(error) {
          return false;
      }
    },

    async delete(eventID) {
      try {
        if (!eventID) {
          return { error: 'No eventID given' }
        }

        let response = await axios.delete(API_URL + '/event/' + eventID, await getHeader());

        if (response.data.message.includes('Successfully deleted the event')) {
            return true;
        }

      } catch(error) {
        return false;
      }
    }
    
}

export default Events;
